import {useState, useContext} from "react";
import { Dialog } from "@material-ui/core"
import styles from '../../Payroll/Modals/PayrollModals.module.css'
import { clearDispersar } from "../../../context/CentralPagos/Actions";
import OutsorcersNominaContext from "../../../context/OutsorcersNomina/OutsorcersNominaContext";
import { clearOutsorcers } from "../../../context/OutsorcersNomina/Actions";

 

const SinSeleccionOutsorcers = (props: any) =>{
  const {state, dispatch} = useContext(OutsorcersNominaContext)
  
  const handleClose = () =>{
    clearOutsorcers({}, dispatch)
  }

  return(
    <Dialog aria-labelledby='costumized-dialog-title' open={state.openSinSeleccion} fullWidth={false}  onClose={handleClose} maxWidth={"md"}>
      <div className={styles.contenedorPrincipal}>
        <div className={styles.contenedorCerrarModal}>
          <div 
            className={styles.cerrarModal}
            onClick={()=> handleClose()}
          >
          </div>
        </div>
        <div className={styles.contenedorPrincipal}>
          <div className={styles.fim_iconoPrincipal}> 
            <div className={styles.fim_iconoComplemento}>
            </div>
          </div>
        </div>
        <div className={styles.tituloAtencion}>
          ¡Atenci&oacute;n!
        </div>
        <div className={styles.em_mensajePrtincipal}>
          No tienes registros seleccionados
        </div>
        <div className={styles.em_contenedorBotones}>
              <button 
                className={styles.em_botonCancelar}
                onClick={()=> handleClose()}
              >
                Cancelar
              </button>
                <button 
                  className={`${styles.botonesAtencion} ${styles.continuarAtencion}`}
                  onClick={()=> handleClose()}
                  >
                    <div>
                      Continuar
                    </div>
                </button>
            </div>
      </div>
    </Dialog>
  )

}


export default SinSeleccionOutsorcers